export enum Permits {
    AG='AG',
    ARCCASSE='ARCCASSE',
    ARCDOC='ARCDOC',
    ARCFATT='ARCFATT',
    ARKIDATA='ARKIDATA', 
    ARCMAN='ARCMAN',
    ASSUNZIONI='ASSUNZIONI',
    BUGDET='BUDGET',
    SIGN='SIGN',
    SURVEYS_GEST='SURVEYS_GEST',
    SURVEYS_REP='SURVEYS_REP',
    SURVEYS_SEND='SURVEYS_SEND',
    TURNIWEB='TURNIWEB',
    CHECKLIST='CHECKLIST',
    MONITORTV='MONITORTV',
    MENSA_INS_MENU='MENSA_INS_MENU',
    MENSA_COSTI='MENSA_COSTI',
    MENSA_VIEW_PREN='MENSA_VIEW_PREN'
   
    
}
